/**
 * Context channel for the site-dashboard layout scope.
 *
 * The site dashboard mounts as a top-level route whose layout
 * (SiteDashboardLayout) owns the active site's snapshot, customer, permissions,
 * and command affordances and hands them to its child subpages. This module is
 * the context object those child routes read — split out from the layout
 * component so a hook can subscribe to the site-dashboard scope without pulling
 * in the layout's full render graph (mirrors app/ScopeContext).
 *
 * Contains:
 * - SiteDashboardLayoutContext — the context object (the layout provides it)
 * - useSiteDashboardLayoutContext — child-route access; throws outside the layout
 */
import { createContext, useContext } from 'react';

const SiteDashboardLayoutContext = createContext(null);

export function useSiteDashboardLayoutContext() {
  const value = useContext(SiteDashboardLayoutContext);
  if (!value) throw new Error('useSiteDashboardLayoutContext must be used inside SiteDashboardLayout');
  return value;
}

export default SiteDashboardLayoutContext;
